import { atomWithStorage } from "jotai/utils";

interface NettixMakeModelIdAtom {
  makeId: number;
  modelId: number;
}

export const nettixMakeModelIdAtom = atomWithStorage<NettixMakeModelIdAtom>(
  "makeModelIdAtom",
  { makeId: 0, modelId: 0 },
  undefined,
  { getOnInit: true }
);

export const nettixBikeTypeId = atomWithStorage<number>(
  "bikeTypeId",
  0,
  undefined,
  { getOnInit: true }
);

export const nettixBodyTypeId = atomWithStorage<number>(
  "bodyTypeId",
  0,
  undefined,
  { getOnInit: true }
);

export const nettixMakeId = atomWithStorage<number>("makeId", 0, undefined, {
  getOnInit: true
});

export const nettixModelId = atomWithStorage<number>("modelId", 0, undefined, {
  getOnInit: true
});

export const nettixModelTypeId = atomWithStorage<number>(
  "modelTypeId",
  0,
  undefined,
  { getOnInit: true }
);
